import { useSelector } from "react-redux";

import HomeAddReserve from "./AddReserve";
import HomeQuickActions from "./QuickActions";
import HomeLastReserves from "./LastReserves";
import CareBrochure from "./CareBrochure";

const HomeContent = () => {
    const profile = useSelector(state => state.auth.profile);

    return (
        <div className="2xm:!px-5 !px-1.5 3xm:py-6 py-3 space-y-6 relative">

            {/* بخش سلام و اطلاعات کاربر */}
            <div>
                <h2 className="text-xl font-bold text-slate-800">
                    سلام {profile?.firstName || "کاربر عزیز"} 👋
                </h2>
                <p className="text-sm text-slate-500 mt-1">
                    امروز می‌خواهید چه کاری انجام دهید؟
                </p>
            </div>

            {/* دکمه افزودن رزرو */}
            <HomeAddReserve />

            {/* دکمه‌های سریع (مشاهده رزروها / تماس با پشتیبانی) */}
            <HomeQuickActions />

            {/* بروشور مراقبت‌ها */}
            <CareBrochure />

            <hr className="block !mt-14" />

            {/* لیست آخرین رزروها */}
            <HomeLastReserves />

        </div>
    );
};

export default HomeContent;